import Play from "./Play";
import DiscImageDevice from "./DiscImageDevice";

export let PlayModule : any = null;

let module_overrides = {
    locateFile: function(path : string) {
        const baseURL = window.location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf( "/" ));
        return baseURL + '/' + path;
    },
    mainScriptUrlOrBlob: "",
};

export let initPlayModule = async function() {
    //ATTENTION : le glue emscripten existe en DEUX exemplaires, qui doivent
    //rester identiques.
    //
    //  src/Play.js    -- importe ci-dessus, integre au bundle par CRA.
    //  public/Play.js -- servi tel quel, recharge par les workers pthread via
    //                    mainScriptUrlOrBlob (la ligne ci-dessous).
    //
    //Apres chaque compilation WASM, copier Play.js vers LES DEUX, et Play.wasm
    //vers public/. N'en mettre a jour qu'un seul produit une erreur trompeuse :
    //
    //    WebAssembly.Table.get(): invalid address N in funcref table of size M
    //
    //Elle ne signale pas un probleme de table, mais un glue perime : les
    //adresses EM_JS (tableau ASM_CONSTS) sont figees a la compilation et ne
    //correspondent plus a celles du .wasm charge.
    module_overrides.mainScriptUrlOrBlob = module_overrides.locateFile('Play.js');
    PlayModule = await Play(module_overrides);
    PlayModule.FS.mkdir("/work");
    PlayModule.discImageDevice = new DiscImageDevice(PlayModule);
    PlayModule.ccall("initVm", "", [], []);
    //Expose le module pour le diagnostic depuis la console du navigateur.
    (window as any).PlayModule = PlayModule;
};
